<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <app-form-control [underlineInputStyle]="true">
    <input
      [formControl]="form.controls.usernameOrEmail"
      appPrimengInputText
      autofocus
      pInputText
      placeholder="Adres e-mail lub nazwa użytkownika" />
  </app-form-control>

  <app-form-control [underlineInputStyle]="true">
    <p-password
      [feedback]="false"
      [fluid]="true"
      [formControl]="form.controls.password"
      appPrimengPassword
      autocomplete="off"
      placeholder="Hasło użytkownika" />
  </app-form-control>

  <app-form-control inputId="f6606075-f6e7-4692-a819-3d04c48d8d18">
    <app-checkbox-with-label
      inputId="f6606075-f6e7-4692-a819-3d04c48d8d18"
      type="short">
      <p-checkbox
        [binary]="true"
        [formControl]="form.controls.rememberMe" />

      <span
        class="text-gray-500"
        label>
        Zapamiętaj mnie
      </span>
    </app-checkbox-with-label>
  </app-form-control>

  <div class="flex items-center justify-between">
    <div>
      <p-button
        appPrimengButton
        label="Zaloguj"
        size="large"
        type="submit" />
    </div>

    <div>
      <ng-content />
    </div>
  </div>
</form>
